function isNativeShareSupported() {
  return Boolean(navigator.share);
}

function share({ title, url }: { title: string; url: string }) {
  return navigator.share({
    title,
    url,
  });
}

export { isNativeShareSupported, share };
